
export function checkPendingTranslation(control, pendingTranslations, language) {
  if (!language || language.toLowerCase() === "english") {
    return { isFailedTranslation: false, isPendingTranslation: false }
  }

  const pendingTranslation = pendingTranslations && pendingTranslations.find(
    ({ library_control }) => library_control.custom_id === control.custom_id
  )

  let isFailedTranslation = false;
  let isPendingTranslation = false;

  if (pendingTranslation) {
    const { type, completedLanguages } = pendingTranslation;
    const isCompletedTranslation = language && completedLanguages && completedLanguages.includes(language.toLowerCase());
    isFailedTranslation = !isCompletedTranslation && type === "failed_translation";
    isPendingTranslation = !isCompletedTranslation && !isFailedTranslation;
  }

  return { isFailedTranslation, isPendingTranslation }
}


export function hasPendingTranslations(control, pendingTranslations, languages) {

  const hasPendingTranslation = languages.reduce(
    (hasPendingTranslation, language) => {
      const { isPendingTranslation } = checkPendingTranslation(control, pendingTranslations, language);
      return hasPendingTranslation || isPendingTranslation;
    },
    false
  );

  return hasPendingTranslation ? "disabled-row" : ""
}


// WEBPACK FOOTER //
// ./src/helpers/checkPendingTranslation.js